// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container-login
{
  z-index: 9999;
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 400px;
  background: white;
  border-radius: 10px;
  box-shadow: 10px 10px 15px rgba(0,0,0,0.05);
}
.container-for-login h1
{
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid silver;
  font-weight: 600;
  font-size: 34px;
}

.login-title-h1 {
  color: black;
}

.container-for-login 
{
  display: flex;
  flex-direction: column;
}

.container-for-login form
{
  padding: 0 40px;
  box-sizing: border-box;
}

form .text-field
{
  position: relative;
  border-bottom: 2px solid #adadad;
  margin: 30px 0;
}

.text-field-input
{
  width: 100%;
  padding: 0 5px;
  height: 40px;
  font-size: 16px;
  border: none;
  background: none;
  outline: none;
}

.text-field-label
{
  position: absolute;
  top: 50%;
  left: 5px;
  color: #adadad;
  transform: translateY(-50%);
  font-size: 16px;
  pointer-events: none;
  transition: .5s;
}

.text-field-span::before
{
  content: '';
  position: absolute;
  top: 40px;
  left: 0;
  width: 0%;
  height: 2px;
  background: var(--primary-color);
  transition: .5s;
}

.text-field-input:focus ~ label,
.text-field-label.focused-field
{
  top: -5px;
  color: var(--primary-color);
}

#password-eye
{
  position: absolute;
  right: 5px;
  bottom: 10px;
  color: var(--dark-secondary-color);
}

#password-eye-closed
{
  position: absolute;
  right: 5px;
  bottom: 10px;
  color: var(--dark-secondary-color);
}

.text-field-input:focus ~ span::before,
.text-field-span.focused-field
{
  width: 100%;
}

.login-submit-button
{
  width: 100%;
  height: 50px;
  background: var(--primary-color);
  border-radius: 25px;
  font-size: 18px;
  color: white;
  font-weight: 700;
  cursor: pointer;
  outline: none;
  transition: 300ms ease;
}

.login-submit-button:hover
{
  background-color: var(--dark-secondary-color);
}

.signup_link
{
  margin: 30px 0;
  text-align: center;
  font-size: 16px;
  color: #666666;
}

#delete-header
{
  font-size : 25px;
  padding : 20px;
  margin-bottom : 20px;
}

#login-submission
{
  width: 100%;
  height: 50px;
  border: 1px solid;
  background: var(--dark-secondary-color);
  border-radius: 25px;
  font-size: 18px;
  color: var(--accent-color);
  font-weight: 700;
  cursor: pointer;
  outline: none;
  border : none;
  transition: 300ms ease;
}

#login-submission:hover
{
  color: var(--dark-secondary-color);
  background: var(--accent-color);
}

#login-popup-background 
{
  background-color:rgb(14, 14, 30);
  opacity: 50%;
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

.hidden 
{
  display: none;
  visibility: hidden;
}

@media all and (max-width : 850px)
{
  #delete-header
  {
    font-size : 20px;
  }
}

@media all and (max-width : 450px)
{

  #delete-header
  {
    font-size : 16px;
  }

  #sign-up-text-field
  {
    margin-top : 20px;
  }

  .container-login
  {
    width : 85%;
  }

  .container form
  {
    padding: 0px 15px;
  }

  .container-for-login form
  {
    padding : 0px 20px;
    padding-bottom: 10px;
  }

  .container-for-login h1
  {
    padding: 20px 0px 20px 0px;
    font-size : 30px;
  }

  .login-submit-button
  {
    height: 40px;
    font-size: 17px;
  }

  .signup_link
  {
    font-size: 13px;
    margin: 20px 0px;
  }

  .text-field-input
  {
    font-size : 14px;
  }

  .text-field-label
  {
    font-size : 14px;
  }
}

@media all and (max-width : 340px)
{
  .container-login
  {
    width : 90%;
  }

  .container-for-login h1
  {
    font-size: 26px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/login.css"],"names":[],"mappings":"AAAA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,2CAA2C;AAC7C;AACA;;EAEE,kBAAkB;EAClB,eAAe;EACf,+BAA+B;EAC/B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,eAAe;EACf,sBAAsB;AACxB;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,cAAc;AAChB;;AAEA;;EAEE,WAAW;EACX,cAAc;EACd,YAAY;EACZ,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;;AAEA;;EAEE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,2BAA2B;EAC3B,eAAe;EACf,oBAAoB;EACpB,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,eAAe;AACjB;;AAEA;;;EAGE,SAAS;EACT,2BAA2B;AAC7B;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kCAAkC;AACpC;;AAEA;;EAEE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,kCAAkC;AACpC;;AAEA;;;EAGE,WAAW;AACb;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,gCAAgC;EAChC,mBAAmB;EACnB,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,6CAA6C;AAC/C;;AAEA;;EAEE,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,cAAc;AAChB;;AAEA;;EAEE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;;EAEE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,uCAAuC;EACvC,mBAAmB;EACnB,eAAe;EACf,0BAA0B;EAC1B,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,aAAa;EACb,sBAAsB;AACxB;;AAEA;;EAEE,kCAAkC;EAClC,+BAA+B;AACjC;;AAEA;;EAEE,gCAAgC;EAChC,YAAY;EACZ,WAAW;EACX,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;AACd;;AAEA;;EAEE,aAAa;EACb,kBAAkB;AACpB;;AAEA;;EAEE;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;;EAGE;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,WAAW;EACb;;EAEA;;IAEE,iBAAiB;EACnB;;EAEA;;IAEE,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA;;IAEE,0BAA0B;IAC1B,gBAAgB;EAClB;;EAEA;;IAEE,YAAY;IACZ,eAAe;EACjB;;EAEA;;IAEE,eAAe;IACf,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;;EAEA;;IAEE,gBAAgB;EAClB;AACF;;AAEA;;EAEE;;IAEE,WAAW;EACb;;EAEA;;IAEE,eAAe;EACjB;AACF","sourcesContent":[".container-login\n{\n  z-index: 9999;\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  width: 400px;\n  background: white;\n  border-radius: 10px;\n  box-shadow: 10px 10px 15px rgba(0,0,0,0.05);\n}\n.container-for-login h1\n{\n  text-align: center;\n  padding: 20px 0;\n  border-bottom: 1px solid silver;\n  font-weight: 600;\n  font-size: 34px;\n}\n\n.login-title-h1 {\n  color: black;\n}\n\n.container-for-login \n{\n  display: flex;\n  flex-direction: column;\n}\n\n.container-for-login form\n{\n  padding: 0 40px;\n  box-sizing: border-box;\n}\n\nform .text-field\n{\n  position: relative;\n  border-bottom: 2px solid #adadad;\n  margin: 30px 0;\n}\n\n.text-field-input\n{\n  width: 100%;\n  padding: 0 5px;\n  height: 40px;\n  font-size: 16px;\n  border: none;\n  background: none;\n  outline: none;\n}\n\n.text-field-label\n{\n  position: absolute;\n  top: 50%;\n  left: 5px;\n  color: #adadad;\n  transform: translateY(-50%);\n  font-size: 16px;\n  pointer-events: none;\n  transition: .5s;\n}\n\n.text-field-span::before\n{\n  content: '';\n  position: absolute;\n  top: 40px;\n  left: 0;\n  width: 0%;\n  height: 2px;\n  background: var(--primary-color);\n  transition: .5s;\n}\n\n.text-field-input:focus ~ label,\n.text-field-label.focused-field\n{\n  top: -5px;\n  color: var(--primary-color);\n}\n\n#password-eye\n{\n  position: absolute;\n  right: 5px;\n  bottom: 10px;\n  color: var(--dark-secondary-color);\n}\n\n#password-eye-closed\n{\n  position: absolute;\n  right: 5px;\n  bottom: 10px;\n  color: var(--dark-secondary-color);\n}\n\n.text-field-input:focus ~ span::before,\n.text-field-span.focused-field\n{\n  width: 100%;\n}\n\n.login-submit-button\n{\n  width: 100%;\n  height: 50px;\n  background: var(--primary-color);\n  border-radius: 25px;\n  font-size: 18px;\n  color: white;\n  font-weight: 700;\n  cursor: pointer;\n  outline: none;\n  transition: 300ms ease;\n}\n\n.login-submit-button:hover\n{\n  background-color: var(--dark-secondary-color);\n}\n\n.signup_link\n{\n  margin: 30px 0;\n  text-align: center;\n  font-size: 16px;\n  color: #666666;\n}\n\n#delete-header\n{\n  font-size : 25px;\n  padding : 20px;\n  margin-bottom : 20px;\n}\n\n#login-submission\n{\n  width: 100%;\n  height: 50px;\n  border: 1px solid;\n  background: var(--dark-secondary-color);\n  border-radius: 25px;\n  font-size: 18px;\n  color: var(--accent-color);\n  font-weight: 700;\n  cursor: pointer;\n  outline: none;\n  border : none;\n  transition: 300ms ease;\n}\n\n#login-submission:hover\n{\n  color: var(--dark-secondary-color);\n  background: var(--accent-color);\n}\n\n#login-popup-background \n{\n  background-color:rgb(14, 14, 30);\n  opacity: 50%;\n  z-index: 10;\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n}\n\n.hidden \n{\n  display: none;\n  visibility: hidden;\n}\n\n@media all and (max-width : 850px)\n{\n  #delete-header\n  {\n    font-size : 20px;\n  }\n}\n\n@media all and (max-width : 450px)\n{\n\n  #delete-header\n  {\n    font-size : 16px;\n  }\n\n  #sign-up-text-field\n  {\n    margin-top : 20px;\n  }\n\n  .container-login\n  {\n    width : 85%;\n  }\n\n  .container form\n  {\n    padding: 0px 15px;\n  }\n\n  .container-for-login form\n  {\n    padding : 0px 20px;\n    padding-bottom: 10px;\n  }\n\n  .container-for-login h1\n  {\n    padding: 20px 0px 20px 0px;\n    font-size : 30px;\n  }\n\n  .login-submit-button\n  {\n    height: 40px;\n    font-size: 17px;\n  }\n\n  .signup_link\n  {\n    font-size: 13px;\n    margin: 20px 0px;\n  }\n\n  .text-field-input\n  {\n    font-size : 14px;\n  }\n\n  .text-field-label\n  {\n    font-size : 14px;\n  }\n}\n\n@media all and (max-width : 340px)\n{\n  .container-login\n  {\n    width : 90%;\n  }\n\n  .container-for-login h1\n  {\n    font-size: 26px;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
